import React from 'react'
import { Grid } from 'semantic-ui-react'
// @ts-ignore
import { GridContainer } from 'shared/StyledComponents'
// @ts-ignore
import FormField, { FormLayout } from 'shared/newFormElements'

import translate from '../../translate'
import { getName, isRequired } from '../../../helpers'

const ContactInformation = ({ fields, selects }) => (
  <Grid.Row>
    <Grid.Column>
      <GridContainer smallPadding>
        <Grid>
          <Grid.Row columns={2}>
            <Grid.Column>
              <FormLayout label={translate('lbl_bus_phone')} visible={!!fields.Phone}>
                <FormField
                  name={getName(fields.Phone)}
                  type="number"
                  maxLength={fields.Phone && fields.Phone.MaxLen}
                  dontParseToInt
                  visible={!!fields.Phone}
                  required={isRequired(fields.Phone)}
                />
              </FormLayout>

              <FormLayout label={translate('lbl_cellphone')} visible={!!fields.CellPhone}>
                <FormField
                  name={getName(fields.CellPhone)}
                  type="number"
                  maxLength={fields.CellPhone && fields.CellPhone.MaxLen}
                  dontParseToInt
                  visible={!!fields.CellPhone}
                  required={isRequired(fields.CellPhone)}
                />
              </FormLayout>

              <FormLayout label={translate('lbl_email')} visible={!!fields.Email}>
                <FormField
                  name={getName(fields.Email)}
                  type="text"
                  visible={!!fields.Email}
                  required={isRequired(fields.Email)}
                  maxLength={fields.Email ? fields.Email.MaxLen : -1}
                />
              </FormLayout>
            </Grid.Column>

            <Grid.Column>
              <FormLayout label={translate('lbl_bus_phone')} visible={!!fields.ORG_Phone}>
                <FormField
                  name={getName(fields.ORG_Phone)}
                  type="number"
                  visible={!!fields.ORG_Phone}
                  maxLength={fields.ORG_Phone && fields.ORG_Phone.MaxLen}
                  dontParseToInt
                  required={isRequired(fields.ORG_Phone)}
                />
              </FormLayout>

              <FormLayout label={translate('lbl_cellphone')} visible={!!fields.ORG_Fax}>
                <FormField
                  name={getName(fields.ORG_Fax)}
                  type="number"
                  maxLength={fields.ORG_Fax && fields.ORG_Fax.MaxLen}
                  dontParseToInt
                  visible={!!fields.ORG_Fax}
                  required={isRequired(fields.ORG_Fax)}
                />
              </FormLayout>

              <FormLayout label={translate('lbl_email')} visible={!!fields.ORG_Web}>
                <FormField
                  name={getName(fields.ORG_Web)}
                  type="text"
                  visible={!!fields.ORG_Web}
                  required={isRequired(fields.ORG_Web)}
                  maxLength={fields.ORG_Web ? fields.ORG_Web.MaxLen : -1}
                />
              </FormLayout>
            </Grid.Column>

            <Grid.Column>
              <FormLayout label={translate('lbl_web')} visible={!!fields.Email1}>
                <FormField
                  name={getName(fields.Email1)}
                  type="text"
                  visible={!!fields.Email1}
                  required={isRequired(fields.Email1)}
                  maxLength={fields.Email1 ? fields.Email1.MaxLen : -1}
                />
              </FormLayout>

              <FormLayout label={translate('lbl_aml_industry')} visible={!!fields.AMLIndustryID}>
                <FormField
                  name={getName(fields.AMLIndustryID)}
                  options={selects.AMLIndustry}
                  type="select"
                  search
                  visible={!!fields.AMLIndustryID}
                  required={isRequired(fields.AMLIndustryID)}
                />
              </FormLayout>

              <FormLayout label="Email Preference" visible={!!fields.EmailPrefID}>
                <FormField
                  name={getName(fields.EmailPrefID)}
                  options={selects.EmailPref}
                  type="select"
                  visible={!!fields.EmailPrefID}
                  required={isRequired(fields.EmailPrefID)}
                  search
                />
              </FormLayout>

              <FormLayout label="KYC Validity" visible={!!fields.KYCValidityID}>
                <FormField
                  name="KYCValidityID"
                  options={selects.KYCValidity}
                  type="select"
                  visible={!!fields.KYCValidityID}
                  required={isRequired(fields.KYCValidityID)}
                  search
                />
              </FormLayout>
            </Grid.Column>

            <Grid.Column>
              <FormLayout label={translate('lbl_passphrase')} visible={!!fields.PassPhrase}>
                <FormField
                  name={getName(fields.PassPhrase)}
                  type="text"
                  visible={!!fields.PassPhrase}
                  required={isRequired(fields.PassPhrase)}
                  maxLength={fields.PassPhrase ? fields.PassPhrase.MaxLen : -1}
                />
              </FormLayout>

              <FormLayout label={translate('lbl_amlstatus')} visible={!!fields.AMLStatusID}>
                <FormField
                  name={getName(fields.AMLStatusID)}
                  options={selects.AMLStatus}
                  type="select"
                  search
                  visible={!!fields.AMLStatusID}
                  required={isRequired(fields.AMLStatusID)}
                />
              </FormLayout>

              <FormLayout label={translate('lbl_amlsuspicious')} visible={!!fields.AMLSuspiciousID}>
                <FormField
                  name={getName(fields.AMLSuspiciousID)}
                  options={selects.AMLSuspicious}
                  type="select"
                  search
                  visible={!!fields.AMLSuspiciousID}
                  required={isRequired(fields.AMLSuspiciousID)}
                />
              </FormLayout>

              <FormLayout label="IBAN" visible={!!fields.IBANAccNo}>
                <FormField
                  name={getName(fields.IBANAccNo)}
                  type="text"
                  required={isRequired(fields.IBANAccNo)}
                  visible={!!fields.IBANAccNo}
                  maxLength={fields.IBANAccNo ? fields.IBANAccNo.MaxLen : -1}
                />
              </FormLayout>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </GridContainer>
    </Grid.Column>
  </Grid.Row>
)

export default ContactInformation
